export default __webpack_public_path__ + "static/media/Zanele_Mahlangu.a9ebaf6b.jpeg";